export default "__VITE_ASSET__DVgWuQtA__"